import type { MachinePublicHydrated } from "@aura-frontend/omnibus-az-client";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setStatTrackingMode } from "../store/slices/session";
import { isPopulatedArray } from "../utils/array";

export const useStatTrackingModeInitializer = (
  machine: MachinePublicHydrated,
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setStatTrackingMode(isPopulatedArray(machine.smartAvailableActive)),
    );
  }, [dispatch, machine.smartAvailableActive]);
};
